import { Currency } from "@sso/types";

interface PriceProps {
  price: number;
  currency: Currency;
}

const Price = ({ price, currency }: PriceProps) => {
  const formatPrice = (price: number, currency: Currency) => {
    return `${currency.symbol}${price.toLocaleString("en-US", {
      minimumFractionDigits: currency.isZeroDecimal ? 0 : 2,
      maximumFractionDigits: currency.isZeroDecimal ? 0 : 2,
    })}`;
  };

  return <>{formatPrice(price, currency)}</>;
};

export default Price;
